export const useCacheDefaultOptions = {
  dependencyTracking: true,
  initialData: null,
  deepCompare: true,
};
